import restClient from "../restClient";

const endpoint = "report-folders";

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

/** Normalize Strapi/core or app list payloads into a flat folder list. */
export const normalizeReportFoldersResponse = (payload) => {
  if (!payload) return { results: [], pagination: null };
  if (Array.isArray(payload.results)) {
    return { results: payload.results, pagination: payload.pagination || null };
  }
  if (Array.isArray(payload.data)) {
    const results = payload.data.map((row) => {
      if (row?.attributes) {
        return {
          id: row.documentId || row.id,
          documentId: row.documentId || row.id,
          ...row.attributes,
          owner_folder:
            row.attributes.owner_folder?.data
              ? {
                  id:
                    row.attributes.owner_folder.data.documentId ||
                    row.attributes.owner_folder.data.id,
                  documentId:
                    row.attributes.owner_folder.data.documentId ||
                    row.attributes.owner_folder.data.id,
                  ...row.attributes.owner_folder.data.attributes,
                }
              : row.attributes.owner_folder,
          reports: Array.isArray(row.attributes.reports?.data)
            ? row.attributes.reports.data.map((r) => ({
                id: r.documentId || r.id,
                ...r.attributes,
              }))
            : row.attributes.reports,
        };
      }
      return {
        ...row,
        id: row.documentId || row.id,
        documentId: row.documentId || row.id,
      };
    });
    return { results, pagination: payload.meta?.pagination || null };
  }
  if (Array.isArray(payload)) {
    return { results: payload, pagination: null };
  }
  return { results: [], pagination: null };
};

/**
 * List report folders.
 * @param {{ ownerId?: string|number, page?: number, pageSize?: number }} [params]
 */
export const getReportFolders = async (params = {}) => {
  const { ownerId, page = 1, pageSize = 200 } = params;
  const query = new URLSearchParams();
  query.set("page", String(page));
  query.set("pageSize", String(pageSize));
  if (ownerId != null && ownerId !== "") {
    query.set("ownerId", String(ownerId));
  }
  const response = await restClient.get(`${endpoint}?${query.toString()}`, authConfig());
  return normalizeReportFoldersResponse(response.data);
};

export const createReportFolder = async (data) => {
  const payload = {
    ...data,
  };
  delete payload.tenant;
  const response = await restClient.post(endpoint, { data: payload }, authConfig());
  const normalized = normalizeReportFoldersResponse({
    data: response.data?.data ? [response.data.data] : Array.isArray(response.data) ? response.data : [response.data],
  });
  return normalized.results[0] || response.data;
};

export const updateReportFolder = async (id, data) => {
  const response = await restClient.put(`${endpoint}/${id}`, { data }, authConfig());
  return response.data;
};

export const deleteReportFolder = async (id) => {
  const response = await restClient.delete(`${endpoint}/${id}`, authConfig());
  return response.data;
};
